import type { Role } from '@/pages/users/types/rbac';

/** FHIR agent.who reference for a directory user. */
export function userToAgentReference(user: { id: string; role: Role }): string {
  return user.role === 'client' ? `Patient/${user.id}` : `Practitioner/${user.id}`;
}
